import { z } from "zod";

export const paymentResultSchema = z.object({
	Id: z.string(),
	CCode: z.string(),
	Amount: z.string(),
	ACode: z.string(),
	Order: z.string(), // request id
	Fild1: z.string(),
	Fild2: z.string(),
	Fild3: z.string(),
	Sign: z.string(),
	Bank: z.string(),
	Payments: z.string(),
	UserId: z.string(),
	Brand: z.string(),
	Issuer: z.string(),
	L4digit: z.string(),
	street: z.string(),
	city: z.string(),
	zip: z.string(),
	cell: z.string(),
	Coin: z.string(),
	Tmonth: z.string(),
	Tyear: z.string(),
	Info: z.string(),
	errMsg: z.string(),
	Hesh: z.string(),
	UID: z.string(),
	SpType: z.string(),
	BinCard: z.string(),
});
export type TPaymentResult = z.infer<typeof paymentResultSchema>;
